import React from "react";
import './App.css';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from "./pages/login";
import Customers from "./pages/customer";
import Orders from "./pages/orders";
import OrderDetails from "./pages/orderdetails";
import Home from "./pages/home";
import Category from "./pages/category";
import Addcategory from "./pages/addcategory";
import Addsubcategory from "./pages/addsubcategory";
import Jute from "./pages/jutebags";
import Cotton from "./pages/cottonbags";
import Nonwoven from "./pages/nonwovenbags";
import Productenquery from "./pages/productenquery";
import Generalenquery from "./pages/generalenquery";
import Coupon from "./pages/coupon";
import Sliders from "./pages/Sliders";
import About from "./pages/about";
import Editsliders from "./pages/editslider";
import Wasend from "./pages/wasend";
import WaChat from "./pages/chat";
import ProductList from "./pages/products";
import AddProduct from "./pages/addProduct";
import EditProduct from "./pages/editProduct";
import Dashboard from "./pages/dashboard";
import WhatsAppMarketing from "./pages/whatsappMarketing";
import WhatsAppOrders from "./pages/whatsappOrders";
import Video from "./Components/Video";
import BannerSection from "./Components/BannerSection";
import MultipleBanner from "./Components/MultipleBanner";
import NewArrivals from "./Components/NewArrival";
import BestSeller from "./Components/BestSeller";
import Popularitems from "./Components/PopularItems";
import TopSelling from "./Components/TopSelling";




const App = () => {
  return(

   <Router>      
      <Routes>
         <Route path="/" element={<Login />} />
         <Route path="/login" element={<Login />} />
        <Route path="/home" element={<Home />} />
        <Route path="/customers" element={<Customers/>}/>
        <Route path="/orders" element={<Orders/>}/>
        <Route path="/orderdetails" element={<OrderDetails />} />
        <Route path="/category" element={<Category/>}/>
        <Route path="/addcategory" element={<Addcategory/>}/>
        <Route path="/addsubcategory" element={<Addsubcategory/>}/> 
        <Route path="/jute" element={<Jute/>}/>  
        <Route path="/cotton" element={<Cotton/>}/> 
        <Route path="/nonwoven" element={<Nonwoven/>}/> 
        <Route path="/productenquery" element={<Productenquery/>}/> 
        <Route path="/generalenquery" element={<Generalenquery/>}/> 
        <Route path="/coupon" element={<Coupon/>}/> 
        <Route path="/sliders" element={<Sliders/>}/> 
        <Route path="/about" element={<About/>}/> 
        <Route path="/editslider" element={<Editsliders/>}/> 
        <Route path="/wasend" element={<Wasend/>}/> 
        <Route path="/wachat" element={<WaChat/>}/> 
        <Route path="/products" element={<ProductList />} />
        <Route path="/add-product" element={<AddProduct />} />
        <Route path="/edit-product" element={<EditProduct />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/wa-marketing" element={<WhatsAppMarketing />} />
        <Route path="/whatsapp-orders" element={<WhatsAppOrders />} />
        <Route path="/video" element={<Video/>}/>
        <Route path="/bannersection" element={<BannerSection/>}/>
        <Route path="/sectionbanners" element={<MultipleBanner/>}/>
        <Route path="/top-selling" element={<TopSelling/>}/>
        <Route path="/new-arrival" element={<NewArrivals/>}/>
        <Route path="/best-seller" element={<BestSeller/>}/>
        <Route path="/popular-items" element={<Popularitems/>}/>       
      </Routes>

    </Router>
  )
}
export default App;